import { useContext, useState } from "react";
import { Link } from "react-router-dom";
import UserContext from "../context/UserContext";
import { useTheme } from "../context/ThemeContext";
import { hasRoleAccess } from "../constants/business";

const NavBar = () => {
    const { user, Logout } = useContext(UserContext);
    const { theme, toggleTheme } = useTheme();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const closeMenu = () => setIsMenuOpen(false);
    return (
        <nav className="relative border-b border-black/10 backdrop-blur dark:border-white/10">
            <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
                <Link to="/" className="text-lg font-semibold tracking-tight"
                    onClick={closeMenu}>
                    💧 ALTAPLAS
                </Link>
                {user
                    &&
                    <button type="button"
                        onClick={() => setIsMenuOpen((open) => !open)}
                        className="rounded-md border dark:border-white/80 border-dark/80 p-2 text-dark dark:text-slate-300
                        sm:hidden" aria-label="Abrir menú">
                        ☰
                    </button>}
                {user
                    &&
                    <div className="hidden items-center gap-4 text-sm text-slate-700 dark:text-slate-300 sm:flex">
                        <Link to="/" className="transition hover:text-white">
                            Dashboard
                        </Link>
                        {
                            hasRoleAccess(user.rol, "catalog")
                            &&
                            <Link to="/products" className="transition hover:text-white">
                                Almacén
                            </Link>
                        }
                        {
                            hasRoleAccess(user.rol, "production")
                            &&
                            <Link to="/production" className="transition hover:text-white">
                                Producción
                            </Link>
                        }
                        {
                            user.rol === "Administrador"
                            &&
                            <Link to="/administrator" className="transition hover:text-white">
                                Reportes
                            </Link>
                        }
                        {hasRoleAccess(user.rol, "sales") && <Link to="/sales" className="transition hover:text-white">Ventas</Link>}
                        {hasRoleAccess(user.rol, "delivery") && <Link to="/delivery" className="transition hover:text-white">Reparto</Link>}
                        {
                            hasRoleAccess(user.rol, "users")
                            &&
                            <Link to="/users" className="transition hover:text-white">
                                Usuarios
                            </Link>
                        }
                        <button onClick={toggleTheme} className="rounded-md border 
                        border-black/10 px-3 py-1.5 transition hover:bg-white/10 dark:border-white/10">
                            {theme === "dark" ? "☀" : "☾"}
                            Cambiar tema
                        </button>
                        <button onClick={Logout} className="rounded-md border border-black/10 px-3 py-1.5 transition
                         hover:bg-white/10 dark:border-white/10">
                            Cerrar Sesión
                        </button>
                    </div>
                }
            </div>
            {user && isMenuOpen
                &&
                <div className="border-t border-black/10 bg-slate-100 shadow-lg dark:border-white/10
             dark:bg-slate-900 sm:hidden">
                    <div className="mx-auto flex max-w-7xl flex-col gap-2 px-4 py-3">
                        <Link to="/" onClick={closeMenu}>
                            Dashboard
                        </Link>
                        {hasRoleAccess(user.rol, "catalog")
                            &&
                            <Link to="/products" onClick={closeMenu}>
                                Almacén
                            </Link>
                        }
                        {hasRoleAccess(user.rol, "production")
                            &&
                            <Link to="/production" onClick={closeMenu}>
                                Producción
                            </Link>
                        }
                        {
                            user.rol === "Administrador"
                            &&
                            <Link to="/administrator" onClick={closeMenu}>
                                Reportes
                            </Link>
                        }
                        {hasRoleAccess(user.rol, "sales") && <Link to="/sales" onClick={closeMenu}>Ventas</Link>}
                        {hasRoleAccess(user.rol, "delivery") && <Link to="/delivery" onClick={closeMenu}>Reparto</Link>}
                        {
                            hasRoleAccess(user.rol, "users")
                            &&
                            <Link to="/users" onClick={closeMenu}>
                                Usuarios
                            </Link>
                        }
                        <button onClick={toggleTheme} className="text-left">
                            {theme === "dark" ? "☀" : "☾"} Cambiar tema
                        </button>
                        <button onClick={Logout} className="text-left">
                            Cerrar Sesión
                        </button>
                    </div>
                </div>
            }
        </nav>
    )
}

export default NavBar